// eslint-disable-next-line
import React, { FC } from 'react';
import { Select } from 'components/forms';
import { TextFieldProps } from 'formik-material-ui';
import dictionary from 'utils/dictionary';
import PhoneAPI from './api';

const PhoneTypeSelector: FC<TextFieldProps> = (props) => {
  const typesOfPhones = PhoneAPI.getTypes();
  return (
    <Select
      SelectProps={{
        SelectDisplayProps: {
          'data-testid': props.id,
        } as any,
      }}
      label={dictionary.clientForm_label_phoneType}
      capitalizeLabel
      items={typesOfPhones}
      {...props}
    />
  );
};

export default PhoneTypeSelector;
